import PropTypes from 'prop-types';
import React, { memo, useEffect } from 'react';
import { forceCheck } from 'react-lazyload';
import styled, { css } from 'styled-components';
import theme from '@cld/theme-helper';
import { useIsCollectionOpen } from '../../common/hooks/useIsCollectionOpen';
import { useSetCollectionOpen } from '../../common/hooks/useSetCollectionOpen';
import { CollectionHeaderItem } from './CollectionHeaderItem';
import CollectionGridItem from './CollectionGridItem';
import { AssetGrid } from './index';

export const StyledAssetGrid = styled(AssetGrid)`
  padding: ${theme`spacing.lg`};

  ${(p) =>
    !p.open &&
    css`
      display: none;
    `}
`;

export const StyledCollectionHeaderItem = styled(CollectionHeaderItem)`
  padding: ${theme`spacing.lg`};

  &:not(:first-child) {
    padding-top: 0;
  }
`;

export const CollectionGridPure = ({ collection, open, onHeaderClick, setPreviewedAssetIndex }) => {
  useEffect(() => {
    // hint to react-lazyload that images might appear in viewport
    forceCheck();
  }, [open]);

  return (
    <>
      <StyledCollectionHeaderItem
        open={open}
        onClick={onHeaderClick}
        title={collection.name}
        count={collection.assets.length}
        downloadLink={collection.downloadUrl}
      />

      <StyledAssetGrid open={open}>
        {collection.assets.map((asset, index) => {
          const handleClick = () => setPreviewedAssetIndex(index);

          return <CollectionGridItem index={index} key={asset.type + '/' + asset.publicId} asset={asset} onClick={handleClick} />;
        })}
      </StyledAssetGrid>
    </>
  );
};

CollectionGridPure.propTypes = {
  open: PropTypes.bool,
  onHeaderClick: PropTypes.func,
  setPreviewedAssetIndex: PropTypes.func.isRequired,
};

export const CollectionGrid = memo(({ collection, ...props }) => {
  const { id } = collection;
  const isOpen = useIsCollectionOpen(id);
  const setOpen = useSetCollectionOpen();
  const onClick = () => setOpen(id, !isOpen);

  return <CollectionGridPure collection={collection} {...props} onHeaderClick={onClick} open={isOpen} />;
});

